<div class="group">
  <h2>
    <button type="button"
            class="w-full flex items-center justify-between px-4 py-3 text-left focus:outline-none focus-visible:ring-2"
            [attr.aria-expanded]="visible"
            [disabled]="disabled"
            [ngClass]="[
                disabled ? 'cursor-not-allowed opacity-50' : (!headerClass ? 'hover:bg-gray-50 dark:hover:bg-neutral-800' : ''),
                headerClass
            ]"
            (click)="toggle()">
            <span class="flex items-center gap-2">
              @if (icon) {
                <i class="h-4 w-4" [innerHTML]="icon | feather: { width: 16, height: 16 }"></i>
              }
              <span>{{ label }}</span>
            </span>
      <span class="ml-4 transition-transform duration-200" [ngClass]="{ 'rotate-180': visible }">▾</span>
    </button>
  </h2>
  @if (visible) {
    <div [id]="id" class="px-4 py-3" [ngClass]="bodyClass">
      <ng-content></ng-content>
    </div>
  }
</div>
